// @flow
import React from 'react'
import { AccountExtrasRef, ContactRef, ContactListRef, GrantorRef, SSIRef, RemaindermenRef } from 'components/References'
import DigitalFile from '../../Account/components/Number/Main/DigitalFile'
import styles from './styles'

type Props = {
  dispatch: Function,
  onSSNReset: Function,
  ticket: Object,
}

const FullAccountDetails = ({ dispatch, onSSNReset, ticket }: Props) => {
  const {
    ables,
    account_number,
    attorneys,
    beneficiary,
    co_grantor,
    consults,
    grantor,
    grantor_relationship,
    referrer,
    remaindermen,
    remaindermen_notes,
    representative,
  } = ticket
  let co_grantor_ref, representative_ref
  if (co_grantor) {
    co_grantor_ref = (
      <GrantorRef
        contact={co_grantor}
        dispatch={dispatch}
        edit={true}
        full={true}
        onSSNReset={onSSNReset}
        relationship={grantor_relationship}
        account_number={account_number}
      />
    )
  }
  if (representative) {
    representative_ref = (
      <ContactRef contact={representative} dispatch={dispatch} edit={true} full={true} onSSNReset={onSSNReset} title="Representative" />
    )
  }
  return (
    <div>
      <ContactRef contact={beneficiary} dispatch={dispatch} edit={true} full={true} onSSNReset={onSSNReset} title="Beneficiary" />
      <GrantorRef
        contact={grantor}
        dispatch={dispatch}
        edit={true}
        full={true}
        onSSNReset={onSSNReset}
        relationship={grantor_relationship}
        account_number={account_number}
      />
      {co_grantor_ref}
      <ContactRef contact={referrer} dispatch={dispatch} edit={true} full={true} onSSNReset={onSSNReset} title="Referrer" />
      {representative_ref}
      <ContactListRef contacts={attorneys} title="Attorneys" />
      <ContactListRef contacts={ables} title="Ables" />
      <ContactListRef contacts={consults} title="Consults" />
      <RemaindermenRef contacts={remaindermen} notes={remaindermen_notes} title="Remaindermen Contacts" />
      <SSIRef
        hasSSI={ticket.has_ssi}
        hasSSIFood={ticket.has_ssi_food}
        hasSSIShelter={ticket.has_ssi_shelter}
        ssiAmount={ticket.ssi_amount}
        ssiApprovalContentType={ticket.ssi_approval_content_type}
        ssiApprovalData={ticket.ssi_approval_data}
        {...ticket}
      />
      <AccountExtrasRef
        hasHeader
        status="pending"
        feeSchedule={ticket.fee_schedule}
        floor={ticket.floor}
        hasBudget={ticket['budget?']}
        hasCustomFeeSchedule={ticket.has_custom_fee_schedule}
        hasDonationClient={ticket.donation_client}
        hasGTHiredCareManagement={ticket['gt_hired_care_management?']}
        hasLien={ticket['lien?']}
        hasNonCashAssets={ticket.has_non_cash_assets}
        hasParticipatingOrg={ticket['participating_org?']}
        hasPublicGuardian={ticket['public_guardian?']}
        hasSpecialTaxSituation={ticket['special_tax_situation?']}
        hasTeams={ticket['teams?']}
        isBurialPrepaid={ticket.is_burial_prepaid}
        isRestricted={ticket.is_restricted}
        pCardLast4={ticket.p_card_last_4}
        spendingPlan={ticket.spending_plan}
        isQIT={ticket.qit}
        hasSubmissionToJurisdiction={ticket.submission_to_jurisdiction_of_court}
        guardianshipAdminCounty={ticket.guardianship_administration_county}
        initialDepositAmount={ticket.initial_deposit_amount}
        monthlyIncomeAmount={ticket.monthly_income_amount}
      />
      <div style={{ paddingBottom: 20 }}>
        <div className={styles.titleSection}>
          <h5>Attachments</h5>
        </div>
        <DigitalFile accountNumber={account_number} bordered={false} />
      </div>
    </div>
  )
}

export default FullAccountDetails
